import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Container,
  CircularProgress,
  Fab,
} from '@mui/material';
import AddIcon from "@mui/icons-material/Add";
import { useAppBar } from '../../providers/AppBarProvider';
import { fetchById } from '../../utils/lib';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../providers/LoadingProvider';
import { useLocation } from 'react-router-dom';
import ViewPage from './ViewPage';

function ViewManufacturer() {
  const location = useLocation();
  const [id, setId] = useState(location.state.id);
  const [manufacturer, setManufacturer] = useState(null);
  const {updateTitle} = useAppBar();
  //const { isLoading, setIsLoading } = useLoading();
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => { 
    setIsLoading(true);
    const fetchData = async () => {
      const manufacturer = await fetchById(id, 'products_manufacturers');
      setManufacturer(manufacturer);
      updateTitle(manufacturer.thumb_url || '', manufacturer.name, manufacturer.email);
      setIsLoading(false);
    };
    fetchData();
  }, []);

  const handleFabClick = async () => {
  };
  
  if (isLoading) return (
    <>
      <CircularProgress
        size={42}
        sx={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-21px', marginLeft: '-21px' }}
      />
    </>
  );

  return (
    <ViewPage 
      isLoading={isLoading}
    >

      {/* Info Section */}
      <Box style={{ marginBottom: '16px' }}>
        <Typography variant="caption">{t('common.name')}</Typography>
        <Typography
          variant="body1"
          style={{ fontSize: '16px' }}
        >
          {manufacturer.name}
        </Typography>
      </Box>

      {/* Text fields with optional visibility */}
      {manufacturer.address && (
        <Box style={{ marginBottom: '16px' }}>
          <Typography variant="caption">{t('common.address')}</Typography>
          <Typography
            variant="body1"
            style={{ fontSize: '16px' }}
          >
            {manufacturer.address}
          </Typography>
        </Box>
      )}
      
      <Box style={{ marginBottom: '16px' }}>
        <Typography variant="caption">{t('common.region')}</Typography>
        <Typography
          variant="body1"
          style={{ fontSize: '16px' }}
        >
          {manufacturer.region.friendly_name}
        </Typography>
      </Box>

      {manufacturer.phone && (
        <Box style={{ marginBottom: '16px' }}>
          <Typography variant="caption">{t('common.phone')}</Typography>
          <Typography
            variant="body1"
            style={{ fontSize: '16px' }}
          >
            {manufacturer.phone}
          </Typography>
        </Box>
      )}

      {manufacturer.email && (
        <Box style={{ marginBottom: '16px' }}>
          <Typography variant="caption">{t('common.email')}</Typography>
          <Typography
            variant="body1"
            style={{ fontSize: '16px' }}
          >
            {manufacturer.email}
          </Typography>
        </Box>
      )}

      {manufacturer.web_page && (
        <Box style={{ marginBottom: '16px' }}>
          <Typography variant="caption">{t('common.webPage')}</Typography>
          <Typography
            variant="body1"
            style={{ fontSize: '16px' }}
          >
            {manufacturer.web_page}
          </Typography>
        </Box>
      )}

      {manufacturer.notes && (
        <Box style={{ marginBottom: '16px' }}>
          <Typography variant="caption">{t('common.notes')}</Typography>
          <Typography
            variant="body1"
            style={{ fontSize: '16px' }}
          >
            {manufacturer.notes}
          </Typography>
        </Box>
      )}

    </ViewPage>
  );
}

export default ViewManufacturer;